module.exports = __webpack_public_path__ + "static/media/product-developent-second.b2c1044f.jpg";